import { render, staticRenderFns } from "./BatchSetDepot.vue?vue&type=template&id=e461f03c&scoped=true"
import script from "./BatchSetDepot.vue?vue&type=script&lang=js"
export * from "./BatchSetDepot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e461f03c",
  null
  
)

export default component.exports